import FeatureCheck from './FeatureCheck'

export default FeatureCheck
